import React from 'react';
import { Stack, Box, Button } from '@mui/material';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import lem_media from '../../components/assets/lem_media.png';
import img_media from '../../components/assets/Illustracion_media_superior.png';
import Requisitos from './Requisitos';
import Image from '../../components/Image';
import FileViewer from '../../components/FileViewer';
import Carusel from '../../components/Carusel';


const B = styled('span')({
  color: '#268c83',
  fontWeight: 'bold',
});

const Img = styled('img')(({theme}) => ({
  maxWidth: '100%',
  maxHeight: 140,
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: '50%',
  },
}));

const Video = styled('video')({
  maxWidth: '100%',
  maxHeight: `400px`,
});

const images = [
  {
    label: 'Jornadas académicas CDMX',
    description: 'Todas las y los seleccionados que pasen a la Etapa 2 realizan un breve viaje académico a la Ciudad de México para participar en actividades como conferencias con expertos, talleres, sesiones de diálogo y visitas a las empresas del CMN. ',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/MS1-jornadas-academicas.jpg',
  },
  {
    label: 'Jornadas académicas CDMX',
    description: 'Todas las y los seleccionados que pasen a la Etapa 2 realizan un breve viaje académico a la Ciudad de México para participar en actividades como conferencias con expertos, talleres, sesiones de diálogo y visitas a las empresas del CMN. ',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/MS2-jornadas-academicas.jpg',
  },
  {
    label: 'Cursos en línea',
    description: 'Durante el programa, participarás en cursos en línea sobre Lenguaje, Matemáticas y Habilidades socioemocionales que potenciarán tu aprendizaje.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/3-cursos+en+linea.png',
  },
  {
    label: 'Seminario de Temas Selectos',
    description: 'A través de conferencias de alto nivel y sesiones de diálogo, las y los estudiantes del programa aprenden sobre algunos de los problemas claves de la actualidad.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/4-seminario+de+temas+selectos.png',
  },
  {
    label: 'Desafío Práctico',
    description: 'En equipos, las y los participantes trabajan a distancia para proponer una solución a un problema de la vida real.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/5-desafio+practico.png',
  },
  {
    label: 'Orientación vocacional',
    description: 'El programa contempla un curso de Orientación Vocacional y una Feria Vocacional que te acompañará en el proceso de crear un plan de vida y escoger una carrera profesional. ',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/6-orientacion+vocacional.png',
  },
  {
    label: 'Tutoría',
    description: 'A las y los seleccionados de la Etapa 2 se les asigna un tutor universitario que les ayude en el proceso de elegir una carrera y dar la transición del nivel medio superior a la universidad.',
    imgPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/7-tutorias.jpg',
  },
  {
    label: 'Testimonios',
    // description: 'A las y los seleccionados de la Etapa 2 se les asigna un tutor universitario que les ayude en el proceso de elegir una carrera y dar la transición del nivel medio superior a la universidad.',
    videoPath:
      'https://s3.amazonaws.com/lideresenmovimiento.s3/Testimoniales+LeM+MS_1.mp4',
  },
]


const buttons = [
  {
    id: 1,
    label: "Convocatoria",
    src: "https://s3.amazonaws.com/lideresenmovimiento.s3/LEM+MS+2024+Convocatoria.pdf",
    type: 'PDF',
  },
  {
    id: 2,
    label: "Preguntas Frecuentes",
    src: "https://s3.amazonaws.com/lideresenmovimiento.s3/LEM+MS+2024+FAQs.pdf",
    type: 'PDF',
  },
];

export default function LemMs() {
  const [open, setOpen] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);

  const handleOpenFile = (button) => {
    setSelectedFile(button);
    setOpen(true);
  };

  const handleGoToApplication = () => {
    let now = new Date();
    if (dayjs(now) > dayjs('Mon Jan 10 2022 00:00:00 GMT-0600 (Central Standard Time)')) {
      window.open('https://lem.learnala.com/apply/69', '_blank');
    } else {
      alert("El Registro abre el 10 de Enero, 2022");
    }
  };

  return (
    <Stack
      alignItems="center"
      sx={{
        py: 5,
        px: '5%',
        flexGrow: 1,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Stack  sx={{ maxWidth: '1200px', width: '100%', boxSizing: 'border-box' }}>
        <Stack direction="row" justifyContent="space-between">
          <Img src={lem_media} alt="Líderes en Movimiento Media Superior" />
          <Img src={img_media} alt="Líderes en Movimiento Media Superior" />
        </Stack>
        <Stack spacing={2} mb={2}>
          <Stack direction="row" justifyContent="space-around" sx={{ mt: 2}}>
            <Box sx={{ textAlign: 'justify' }}>
            <B>LeM Media Superior</B> es un programa extracurricular de potenciación académica y <B>liderazgo social</B> diseñado e
            implementado por El Colegio de México (Colmex) y dirigido a jóvenes de la comunidad del CMN y de las empresas
            que lo conforman. El programa busca estudiantes de bachilleratos públicos y privados con mentes abiertas, un <B>alto
            sentido ético</B> y con iniciativas de <B>liderazgo social</B>.
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-around" sx={{ mt: 2}}>
            <Box sx={{ textAlign: 'justify' }}>
            El programa está dirigido a <B>estudiantes de media superior con talento intelectual sobresaliente</B>, no necesariamente
            interpretado como buenas calificaciones. Además, el/la estudiante debe tener <B>interés por mejorar su entorno</B> y
            mostrar <B>disposición por esforzarse y aprender</B>. Se seleccionará a 1,000 estudiantes en la primera fase virtual y 
            los <B>100 con mejor desempeño</B> pasarán a una segunda fase presencial.
            </Box>
          </Stack>
          <Stack sx={{ color: '#cb912f', fontWeight: 'bold' }}>
            ¡Registrate antes del 15 de marzo! 
          </Stack>
        </Stack>
        <Video id="video_MS1" src={"https://s3.amazonaws.com/lideresenmovimiento.s3/queslem.mp4"} controls autoPlay playsInline muted loop />
        {/* <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2, mb: 1 }}>Testimonios</Box> */}
        {/* <Video id="video_MS" src={"https://s3.amazonaws.com/lideresenmovimiento.s3/testimoniales_ms.mp4"} controls autoPlay playsInline muted loop /> */}
        <Requisitos />
        <Image
          sx={{ maxWidth: '1200px', objectFit: 'contain' }}
          mt={2}
          src="https://s3.amazonaws.com/lideresenmovimiento.s3/ComponentesMS.png"
          alt="Componentes Media Superior"
          allowFullScreen
        />
        <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2 }}>Convocatoria</Box>
        {buttons.map((button) => (
          <Button key={`file${button.id}`} sx={{ mt: 2 }} variant="outlined" onClick={() => handleOpenFile(button)}>{button.label}</Button>
        ))}
        <Button sx={{ mt: 2 }} variant="contained" onClick={handleGoToApplication}>Regístrate aquí</Button>
        <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2 }}>Carrusel de Fotos</Box>
        <Carusel images={images} />
        {open && (
          <FileViewer
            open={open}
            setOpen={setOpen}
            src={selectedFile.src}
            label={selectedFile.label}
            type={selectedFile.type}
          />
        )}
      </Stack>
    </Stack>
  );
}
